import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../context";
import { loginCallback, loginVerify } from "../../Service/Api/auth";
import schema from "./loginValidation";
import generateHMAC from "./generateHMAC";
import { useDebouncedApiCall } from "../../hooks";

const useLoginForm = () => {
  const { login } = useAuth();
  const { call } = useDebouncedApiCall();

  const defaultEmail = process.env.REACT_APP_LOGIN_EMAIL || "";
  const defaultPassword = process.env.REACT_APP_LOGIN_PASSWORD || "";

  const {
    register,
    handleSubmit,
    setError,
    control,
    formState: { errors, isValid, isSubmitting },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      email: defaultEmail,
      password: defaultPassword,
    },
  });

  const onSubmit = async ({ email, password }) => {
    try {
      const res = await call(() =>
        loginCallback({ email, password, app_name: "INTRENAL_ADMIN_PANEL" }),
      );
      const { user_id, challenge } = res.data;
      if (!!challenge) {
        const challange_reponse = await generateHMAC(challenge);
        const verifyRes = await loginVerify({ challange_reponse, user_id });
        login(verifyRes.data);
      } else {
        login(res.data);
      }
    } catch (err) {
      console.log(err);
      const message =
        err?.response?.data?.message || "Incorrect username or password";
      setError("root", { type: "manual", message });
    }
  };

  return {
    control,
    handleSubmit,
    onSubmit,
    errors,
    isValid,
    isSubmitting,
  };
};

export default useLoginForm;
